import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, projectResource }) =>
    present(
      repository
        .getProjectResourceAllocations(project, projectResource)
        .then((resourceAllocations) => ({
          project,
          resourceAllocations,
          projectResource,
        }))
        .catch(() => Promise.reject({ project, projectResource })),
    );
}

export type { Interactor };

export { createInteractor };
